import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Dashboard from './Pages/Dashboard/Dashboard';

const App = ({ page }) => {
  return (
    <div>
      {page === 'dashboard' && <Dashboard />}
    </div>
  );
};

export default App;
